export const siteInfo = {
  brand: "FATMA ANGAY GÜZELLİK SALONU",
  shortBrand: "Fatma Angay",
  tagline: "Güzelliğiniz Her Mevsim Sizinle",
  phoneDisplay: "0542 185 02 01",
  instagramHandle: "@fatmaangay.guzellik",
  instagramUrl: "https://instagram.com/fatmaangay.guzellik",
  addressLine1: "Demirtaş Sakarya Mahallesi",
  addressLine2: "Demirtaş Sanayi Çevre Yolu Caddesi No:2/1",
  addressLine3: "Osmangazi / Bursa",
  locationShort: "DEMİRTAŞ / OSMANGAZİ / BURSA",
  logo: "https://storage.helloreaddy.io/project_files/c4f2c66c-1a08-4ed3-87f2-fa775eeabedc/8648fc22-aa64-4ffe-9af3-75a484612326_compressed_logo.webp",
  defaultMessage:
    "Merhaba, Fatma Angay Güzellik Salonu hizmetleri hakkında bilgi almak ve randevu oluşturmak istiyorum.",
};

export const navItems = [
  { label: "Ana Sayfa", href: "#anasayfa" },
  { label: "Kampanyalar", href: "#kampanyalar" },
  { label: "Hizmetler", href: "#hizmetler" },
  { label: "Galeri", href: "#galeri" },
  { label: "Hakkımızda", href: "#hakkimizda" },
  { label: "İletişim", href: "#iletisim" },
];